import { render, staticRenderFns } from "./teacherIndex.vue?vue&type=template&id=24de8a6e&scoped=true&"
import script from "./teacherIndex.vue?vue&type=script&lang=js&"
export * from "./teacherIndex.vue?vue&type=script&lang=js&"
import style0 from "./teacherIndex.vue?vue&type=style&index=0&id=24de8a6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24de8a6e",
  null
  
)

export default component.exports